var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGewerblicherRechtsschutzUndUrheberrecht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.03 144.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00355b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.4.05c37.07-1.36,69.37,25.95,74.03,62.7,6.03,47.54-34.84,87.56-82.26,80.46C29.59,138.48,4.63,112.97.59,81.28-4.78,39.17,27.07,1.6,69.4.05ZM105.2,62.57c-.42-14.29-11.3-24.9-24.95-27.41-13.03-2.4-27.16,1.47-34.87,12.64-8.82,12.76-8.81,35.31-.16,48.15,7.76,11.51,22.07,15.34,35.35,12.92s24.33-12.78,24.63-27.06h-17.32c-1.09,8.82-9.08,13.99-17.69,12.34-7.06-1.35-10.84-7.65-12.2-14.23-2.04-9.84-.65-26.51,11.02-29.75,8.92-2.48,17.86,3.11,18.76,12.4h17.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGewerblicherRechtsschutzUndUrheberrecht);
export default __webpack_public_path__ + "static/media/GewerblicherRechtsschutzUndUrheberrecht.48a74aed12edbaea286221026fc9f239.svg";
export { ForwardRef as ReactComponent };